import { useNuxtApp } from "nuxt/app";

export const useLayoutManager = () => {
  const { $layoutManager } = useNuxtApp();
  return $layoutManager;
};
